const klaviyoPopUp = document.querySelector('#klaviyoProductModal');
const host = window.klaviyoCustomModal
const container = host.querySelector('.parent-container');

//Form elements
const form = host.querySelector('form');
const submitButton = form.querySelector('button[type="submit"]');
const completedMessage = form.querySelector('#completed_message');
const errorMessage = form.querySelector('#error_message');


container.addEventListener('click', (event) => {
  const target = event.target;
  const closeButton = target.classList.contains('klaviyo-bis-close'); 
  if(closeButton){
    klaviyoPopUp.classList.add('hide'); 
    completedMessage.style.display = 'none';
    errorMessage.style.display = 'none';
    submitButton.disabled = false; 
    submitButton.textContent = 'Get on the Waitlist'; 
    submitButton.style.display = 'block';  }
})


form.addEventListener('submit', async (event) => {
  event.preventDefault();
  
  const productId = form.querySelector('#variant_select #product').value;
  const selectedVariantId = form.querySelector('#variant_select #variants').value;
  const email = form.querySelector('#email').value;
  const successPara = container.querySelector('#completed_message');
  const errorPara = container.querySelector('#error_message');
  
  // Disable the submit button and show loading state
  
  submitButton.disabled = true;
  submitButton.textContent = 'Submitting...';

  try {
    const result = await submitDataToKlaviyo(selectedVariantId, email);
    
    if (result.success) {
      console.log('Submission successful. Status:', result.status);
      
      // Show success message
      
      completedMessage.style.display = 'block';
      
      // Hide the form
      submitButton.style.display = 'none';
    } else {
      throw new Error(result.error);
    }
    
  } catch (error) {
    console.error('Submission failed:', error);
    
    // Show error message
    
    errorMessage.textContent = 'Failed to submit. Please try again later.';
    errorMessage.style.display = 'block';
    
  } 
});



async function submitDataToKlaviyo(variantId, email) {
  try {
    const selectedVariantId = variantId;
    console.log('Selected Variant ID: ' + selectedVariantId);
    
    const payloadID = '$shopify:::$default:::' + selectedVariantId;
    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
              "type": "profile",
              "attributes": {
                "email": email,
              }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": payloadID
            }
          }
        }
      }
    };

    const requestOptions = {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "revision": "2024-06-15"
      },
      body: JSON.stringify(payload),
    };

    const response = await fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=qtDwhT", requestOptions);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Instead of parsing JSON, we'll just return the response status
    return { success: true, status: response.status };

  } catch (error) {
    console.error("Error submitting data to Klaviyo:", error);
    return { success: false, error: error.message };
  }
}